import { render, staticRenderFns } from "./WideDocsData.vue?vue&type=template&id=017cb9be&scoped=true&"
import script from "./WideDocsData.vue?vue&type=script&lang=js&"
export * from "./WideDocsData.vue?vue&type=script&lang=js&"
import style0 from "./WideDocsData.vue?vue&type=style&index=0&id=017cb9be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017cb9be",
  null
  
)

export default component.exports